module.exports = __webpack_public_path__ + "static/media/urbanClimate_interIntra_white_logo.a4b91983.svg";